import styled from 'styled-components';

export const DistributionListContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.backGroundColor};
`;
